var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',[_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',[_vm._v("fas fa-spinner fa-spin")])],1),_vm._v(" "+_vm._s(_vm.state)+" "),(_vm.state === 'In queue')?_c('v-avatar',{staticStyle:{"cursor":"pointer"},attrs:{"right":""},on:{"click":_vm.handleDeleteClick}},[_c('v-icon',{attrs:{"size":"large"}},[_vm._v("far fa-trash-alt")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }